import React from "react";
import { default as NextAbsences } from "components/Dashboard/Dashboard_NextAbsences"

const Card_NextAbsences = (props) => {
	// console.log(props);

	return (
		<article className="card card-upcoming-absences">
			<NextAbsences />
		</article>
	);
};

export default Card_NextAbsences;